import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Box, Avatar, Accordion, AccordionSummary, AccordionDetails, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Breadcrumbs, Link } from "@mui/material";
import { Menu as MenuIcon, Help as HelpIcon } from "@mui/icons-material";
import { Typography, Card, Chip, IconButton, CardContent, Paper, Container, Tooltip as TooltipCustom, useMediaQuery, Backdrop, CircularProgress, useTheme, Stack } from "@mui/material";
// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMaterialUIController, setMiniSidenav } from "context";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import Banner1 from "assets/images/Retailers/7-Eleven-Logo-11.png";
import "./retails.css";
import KpiMetricscards from "components/KPI/KpiMetricscards";
import TimeSeriescards from "components/TimeSeries/TimeSeriescards";
import HighlightsCards from "components/Highlights/Highlightscard";
import PieLegendCard from "components/Visualizations/Piecharts";
import Barcharts from "components/Visualizations/Barcharts";
import Map from "components/Visualizations/Map";
import LineChartSubBrand from "components/Visualizations/Linechartsubbrand";
import TopSkuBarChart from "components/Visualizations/SkuBarchart";
import LineChartsale from "components/Visualizations/LineChartsale";
import InventoryCharts from "components/Visualizations/Inventorycharts";
import WaterfallChart from "components/Visualizations/waterfallchart";
import DoubleBarChart from "components/Visualizations/DoubleBarcharts";
import BrandPriceDumbbellChart from "components/Visualizations/DumbleBarchart";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import FilterChip from "components/FilterChip/FilterChip";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { getTimeSeriesLabels } from "../../../components/TimeSeries/monthUtils";

import Datamap from "./Datamap";
import { fetchRetailers } from "services/retailers.service";
function RetailsDetailspage({ subcategoryToken }) {
  const { lastYearSameMonth, currentMonthLabel, prevMonthLabel } = getTimeSeriesLabels();

  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Below 900px
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg")); // Between 900px and 1200px

  // State for API data

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* FIX leaflet marker icon */
  /* ===== EXACT PIN SVG (MATCHES IMAGE) ===== */
  const pinIcon = new L.Icon({
    iconUrl:
      "data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='42' viewBox='0 0 32 42'>\
<path d='M16 0C7.2 0 0 7.2 0 16c0 11.8 16 26 16 26s16-14.2 16-26C32 7.2 24.8 0 16 0z' fill='%236bb6ff'/>\
<circle cx='16' cy='16' r='6' fill='white'/>\
</svg>",
    iconSize: [32, 42],
    iconAnchor: [16, 42],
    popupAnchor: [0, -36],
  });

  const CITY_COORDS = {
    "Coal Valley,IL": [41.4286, -90.4607],
    "East Moline,IL": [41.5009, -90.4446],
    "St Louis,MO": [38.627, -90.1994],
    "St Peters,MO": [38.7875, -90.6299],
    "Kansas City,MO": [39.0997, -94.5786],
    "Salt Lake City,UT": [40.7608, -111.891],
    "Denver,CO": [39.7392, -104.9903],
    "Colorado Springs,CO": [38.8339, -104.8214],
    "Aurora,CO": [39.7294, -104.8319],
    "Tucson,AZ": [32.2226, -110.9747],
    "Phoenix,AZ": [33.4484, -112.074],
    "Scottsdale,AZ": [33.4942, -111.9261],
    "Olathe,KS": [38.8814, -94.8191],
    "Lakewood,CO": [39.7047, -105.0814],
    "Moline,IL": [41.5067, -90.5151],
    "Provo,UT": [40.2338, -111.6585],
    "Tempe,AZ": [33.4255, -111.94],
    "Mesa,AZ": [33.4152, -111.8315],
    "Westminster,CO": [39.8367, -105.0372],

    "Pittsburgh,PA": [40.4406, -79.9959],
    "Charleston,WV": [38.3498, -81.6326],
    "Troy,MI": [42.6064, -83.1498],
    "Detroit,MI": [42.3314, -83.0458],
    "Harrisburg,PA": [40.2732, -76.8867],
    "Butler,PA": [40.8612, -79.8953],
    "Ann Arbor,MI": [42.2808, -83.743],
    "Toledo,OH": [41.6528, -83.5379],
    "Akron,OH": [41.0814, -81.519],
    "Bethlehem,PA": [40.6259, -75.3705],
    "Virginia Beach,VA": [36.8529, -75.978],
    "Asbury Park,NJ": [40.2204, -74.0121],
    "Herndon,VA": [38.9696, -77.3861],
    "Chicago,IL": [41.8781, -87.6298],
    "Richmond,VA": [37.5407, -77.436],
    "Baltimore,MD": [39.2904, -76.6122],
    "Dover,DE": [39.1582, -75.5244],
    "Newark,DE": [39.6837, -75.7497],
    "Philadelphia,PA": [39.9526, -75.1652],
    "Washington,DC": [38.9072, -77.0369],

    "New York,NY": [40.7128, -74.006],
    "Kew Gardens,NY": [40.7096, -73.8304],
    "Massapequa,NY": [40.6804, -73.4743],
    "Latham,NY": [42.747, -73.759],
    "Boston,MA": [42.3601, -71.0589],
    "Danbury,CT": [41.3948, -73.454],
    "Nashua,NH": [42.7654, -71.4676],
    "Portland,ME": [43.6591, -70.2568],
    "Providence,RI": [41.824, -71.4128],
    "Rochelle Park,NJ": [40.9073, -74.0751],
    "Brighton,MA": [42.3464, -71.1627],
    "Bondville,VT": [43.1601, -72.8284],
    "Lincoln,RI": [41.9218, -71.4695],
    "Springvale,ME": [43.4679, -70.7934],
    "Niagara Falls,NY": [43.0962, -79.0377],
    "Rochester,NY": [43.1566, -77.6088],
    "Hackensack,NJ": [40.8859, -74.0435],
    "Hartford,CT": [41.7658, -72.6734],
    "Fall River,MA": [41.7015, -71.155],
    "Dover,NH": [43.1979, -70.8737],

    "Fort Lauderdale,FL": [26.1224, -80.1373],
    "Miami,FL": [25.7617, -80.1918],
    "Houston,TX": [29.7604, -95.3698],
    "Dallas,TX": [32.7767, -96.797],
    "St Petersburg Beach,FL": [27.7253, -82.7412],
    "Austin,TX": [30.2672, -97.7431],
    "Charlotte,NC": [35.2271, -80.8431],
    "Oklahoma City,OK": [35.4676, -97.5164],
    "Yukon,OK": [35.5067, -97.7625],
    "Lexington,SC": [33.9815, -81.2362],
    "Lebanon,TN": [36.2081, -86.2911],
    "Nashville,TN": [36.1627, -86.7816],
    "Rock Hill,SC": [34.9249, -81.0251],
    "San Marcos,TX": [29.8833, -97.9414],
    "Largo,FL": [27.9095, -82.7873],
    "Tampa,FL": [27.9506, -82.4572],
    "Indian Trail,NC": [35.0768, -80.6698],
    "Mesquite,TX": [32.7668, -96.5992],
    "Pasadena,TX": [29.6911, -95.2091],
    "San Antonio,TX": [29.4241, -98.4936],

    "Huntington Beach,CA": [33.6595, -117.9988],
    "Costa Mesa,CA": [33.6411, -117.9187],
    "Palm Springs,CA": [33.8303, -116.5453],
    "Fresno,CA": [36.7378, -119.7871],
    "Santa Cruz,CA": [36.9741, -122.0308],
    "San Francisco,CA": [37.7749, -122.4194],
    "Pomona,CA": [34.0551, -117.749],
    "Los Angeles,CA": [34.0522, -118.2437],
    "San Diego,CA": [32.7157, -117.1611],

    "Las Vegas,NV": [36.1699, -115.1398],
    "Portland,OR": [45.5051, -122.675],
    "Boulder City,NV": [35.978, -114.8329],
    "Eugene,OR": [44.0521, -123.0868],
    "Vancouver,WA": [45.6387, -122.6615],
    "Tacoma,WA": [47.2529, -122.4443],
    "Seattle,WA": [47.6062, -122.3321],
    "Reno,NV": [39.5296, -119.8138],
    "Incline Village,NV": [39.2513, -119.9729],
    "El Dorado Hills,CA": [38.6857, -121.0822],
    "Sacramento,CA": [38.5816, -121.4944],
  };

  useEffect(() => {
    const header = document.querySelector(".MuiAppBar-root");
    if (header) {
      header.style.display = "none";
    }
  }, []);

  // Toggle sidenav from the page menu icon
  const isTogglingSidenavRef = useRef(false);
  const handleToggleSidenav = useCallback(() => {
    if (isTogglingSidenavRef.current) return;
    isTogglingSidenavRef.current = true;
    // Defer to next frame to avoid blocking heavy charts paint
    requestAnimationFrame(() => {
      setMiniSidenav(dispatch, !miniSidenav);
      setTimeout(() => {
        isTogglingSidenavRef.current = false;
      }, 150);
    });
  }, [dispatch, miniSidenav]);

  const retail = location.state?.retail;

  console.log(retail, "retailers details");
  const [retailersData, setRetailersData] = useState(null);
  const [highlightsActiveChipName, setHighlightsActiveChipName] = useState("YTD");
  const [visualizationActiveChipName, setVisualizationActiveChipName] = useState("YTD");

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);
        const retailersResponse = await fetchRetailers(visualizationActiveChipName, highlightsActiveChipName);
        console.log("Retailers API Response:", retailersResponse);

        const retailersItem = retailersResponse || null;
        setRetailersData(retailersItem);
      } catch (error) {
        console.error("Failed loading static mocks or transforming data:", error);
        setError("Failed to load static mock data. Check competitive_analysis/data/allMocks.json");
      } finally {
        setLoading(false);
      }
    };
    fetchAllData();
  }, [visualizationActiveChipName, highlightsActiveChipName]);

  console.log("Rendering Retailers Details Page", miniSidenav);
  const [activeIdx, setActiveIdx] = React.useState(0);
  const accordionData = [
    {
      title: "Retailer Overview",
      doors: "12,345",
      status: "Active",
      Channel: retail?.channel,
      Coverage: retail?.coverage,
      ParentCompany: retail?.parent,
      RouteTomarket: retail?.route,
    },
    {
      title: "TBD",
      doors: "TBD",
      status: "Active",
    },
    {
      title: "TBD",
      doors: "TBD",
      status: "Active",
    },
  ];
  const [expanded, setExpanded] = useState("panel0"); // **first card open**

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const metricData = [
    { title: "Rank in Market", value: "#2", growth: "1" },
    { title: "Market Share %", value: "34%", growth: "12%" },
    { title: "Total Points of Distribution", value: "12,345", growth: "233" },
    { title: "Active SKUs", value: "22", growth: "8" },
  ];

  const stateMap = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  };
  const [formateddata, setformateddata] = useState([]);
  useEffect(() => {
    const formatted = Datamap.map((item) => {
      const cityKey = `${item.City},${item.State}`;
      const coords = CITY_COORDS[cityKey];

      return {
        ...item,
        stateName: stateMap[item.State] || item.State,
        lat: coords ? coords[0] : null,
        lng: coords ? coords[1] : null,
      };
    });

    setformateddata(formatted);
  }, []);

  console.log(formateddata, "####");

  const rows1 = [
    { region: "South", division: "Sun Belt", state: "Florida", number: "3918023", address: "133 NE 2nd Ave CU1, Miami, FL 33132" },
    { region: "South", division: "Sun Belt", state: "Florida", number: "2341123", address: "9045 N Pinebrook Ave, Orlando, FL 32817" },
    { region: "South", division: "Sun Belt", state: "Florida", number: "8928128", address: "133 NE 2nd Ave CU1, Miami, FL 33132" },
    { region: "South", division: "Sun Belt", state: "Florida", number: "2313134", address: "2197 Palm Ridge Pkwy, Sarasota, FL 34231" },
    { region: "South Central", division: "Gulf", state: "Texas", number: "8927784", address: "5642 Canyon Mesa, El Paso, TX 79912" },
    { region: "South Central", division: "Gulf", state: "Texas", number: "2346619", address: "6731 Old Vista Rd, San Antonio, TX 78249" },
    { region: "South Central", division: "Gulf", state: "Texas", number: "3054212", address: "4429 Shady Arroyo Ct, Plano, TX 78414" },
  ];

  //Kpis cards data

  console.log(retailersData, "retailersData in retails details page");

  const formatToMillions = (value) => {
    return value == null || value === "-" ? "-" : (Number(value) / 1_000_000).toFixed(1);
  };

  const truncateDecimal = (num, decimals = 1) => {
    const factor = Math.pow(10, decimals);
    return Math.floor(num * factor) / factor;
  };

  const Kpiscardsdata = [
    {
      title: "Reported Dollars Sold",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerReportedDollarsSolds?.items?.cMvsGoal ? `${retailersData?.retailerReportedDollarsSolds?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerReportedDollarsSolds?.items?.cMvsLM ? `${retailersData?.retailerReportedDollarsSolds?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.currentMonth)}M`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerReportedDollarsSolds?.items?.cQvsGoal ? `${retailersData?.retailerReportedDollarsSolds?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerReportedDollarsSolds?.items?.cQvsLQ ? `${retailersData?.retailerReportedDollarsSolds?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.currentQuarter)}M`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerReportedDollarsSolds?.items?.cYvsGoal ? `${retailersData?.retailerReportedDollarsSolds?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerReportedDollarsSolds?.items?.cYvsLY ? `${retailersData?.retailerReportedDollarsSolds?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.currentYear)}M`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Reported Units Sold",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerReportedUnitsSolds?.items?.cMvsGoal ? `${retailersData?.retailerReportedUnitsSolds?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerReportedUnitsSolds?.items?.cMvsLM ? `${retailersData?.retailerReportedUnitsSolds?.items?.cMvsLM}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.currentMonth)}`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerReportedUnitsSolds?.items?.cQvsGoal ? `${retailersData?.retailerReportedUnitsSolds?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerReportedUnitsSolds?.items?.cQvsLQ ? `${retailersData?.retailerReportedUnitsSolds?.items?.cQvsLQ}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.currentQuarter)}`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerReportedUnitsSolds?.items?.cYvsGoal ? `${retailersData?.retailerReportedUnitsSolds?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerReportedUnitsSolds?.items?.cYvsLY ? `${retailersData?.retailerReportedUnitsSolds?.items?.cYvsLY}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.currentYear)}`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "All Commodity Volume (ACV)",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerACVDollarsKPI?.items?.cMvsGoal ? `${retailersData?.retailerACVDollarsKPI?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerACVDollarsKPI?.items?.cMvsLM ? `${retailersData?.retailerACVDollarsKPI?.items?.cMvsLM}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.currentMonth)}`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerACVDollarsKPI?.items?.cQvsGoal ? `${retailersData?.retailerACVDollarsKPI?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerACVDollarsKPI?.items?.cQvsLQ ? `${retailersData?.retailerACVDollarsKPI?.items?.cQvsLQ}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.currentQuarter)}`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerACVDollarsKPI?.items?.cYvsGoal ? `${retailersData?.retailerACVDollarsKPI?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerACVDollarsKPI?.items?.cYvsLY ? `${retailersData?.retailerACVDollarsKPI?.items?.cYvsLY}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.currentYear)}`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Dollar Sold per Avg Weekly TPD",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cMvsGoal ? `${retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cMvsLM ? `${retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.currentMonth)}K`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cQvsGoal ? `${retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cQvsLQ ? `${retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.currentQuarter)}K`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cYvsGoal ? `${retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cYvsLY ? `${retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.currentYear)}M`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Units Sold per Avg Weekly TPD",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cMvsGoal ? `${retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cMvsLM ? `${retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cMvsLM}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.currentMonth)}`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cQvsGoal ? `${retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cQvsLQ ? `${retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cQvsLQ}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.currentQuarter)}`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cYvsGoal ? `${retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cYvsLY ? `${retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cYvsLY}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.currentYear)}`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Sales Growth Rate (Dollars Sold)",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cMvsGoal ? `${retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cMvsLM ? `${retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cMvsLM}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.currentMonth)}%`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cQvsGoal ? `${retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cQvsLQ ? `${retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cQvsLQ}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.currentQuarter)}%`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cYvsGoal ? `${retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cYvsLY ? `${retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cYvsLY}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.currentYear)}%`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "Average Price per Unit",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerAveragePricePerUnits?.items?.cMvsGoal ? `${retailersData?.retailerAveragePricePerUnits?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerAveragePricePerUnits?.items?.cMvsLM ? `${retailersData?.retailerAveragePricePerUnits?.items?.cMvsLM}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.currentMonth)}`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerAveragePricePerUnits?.items?.cQvsGoal ? `${retailersData?.retailerAveragePricePerUnits?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerAveragePricePerUnits?.items?.cQvsLQ ? `${retailersData?.retailerAveragePricePerUnits?.items?.cQvsLQ}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.currentQuarter)}`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerAveragePricePerUnits?.items?.cYvsGoal ? `${retailersData?.retailerAveragePricePerUnits?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerAveragePricePerUnits?.items?.cYvsLY ? `${retailersData?.retailerAveragePricePerUnits?.items?.cYvsLY}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.currentYear)}`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "% Dollars Sold on Promotion",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cMvsGoal ? `${retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cMvsLM ? `${retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cMvsLM}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.currentMonth)}%`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cQvsGoal ? `${retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cQvsLQ ? `${retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cQvsLQ}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.currentQuarter)}%`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cYvsGoal ? `${retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cYvsLY ? `${retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cYvsLY}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.currentYear)}%`,
          status: "increase",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
    {
      title: "% Dollars Sold on Display",
      values: [
        {
          label: "MTD",
          change: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cMvsGoal ? `${retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cMvsGoal}%` : "0%",
          changely: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cMvsLM ? `${retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cMvsLM}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.currentMonth)}%`,
          status: "increase",
          title: "Month",
          lyValue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.lastMonth)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.goalsCurrentMonth)}M`,
        },
        {
          label: "QTD",
          change: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cQvsGoal ? `${retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cQvsGoal}%` : "0%",
          changely: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cQvsLQ ? `${retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cQvsLQ}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.currentQuarter)}%`,
          status: "increase",
          title: "Quarter",
          lyValue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.lastQuarter)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.goalsCurrentQuarter)}M`,
        },
        {
          label: "YTD",
          change: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cYvsGoal ? `${retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cYvsGoal}%` : "0%",
          changely: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cYvsLY ? `${retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cYvsLY}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.currentYear)}%`,
          status: "decrease",
          title: "Year",
          lyValue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.lastYear)}M`,
          glvalue: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.goalsCurrentYear)}M`,
        },
      ],
    },
  ];

  //second section cards
  const timeSeriesCardsdata = [
    {
      title: "Reported Dollars Sold",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerReportedDollarsSolds?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerReportedDollarsSolds?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerReportedDollarsSolds?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerReportedDollarsSolds?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedDollarsSolds?.items?.lastMonth)}M`,
          status: "increase",
          arrow: "left",
        },
      ],
    },
    {
      title: "Reported Units Sold",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerReportedUnitsSolds?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerReportedUnitsSolds?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerReportedUnitsSolds?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerReportedUnitsSolds?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerReportedUnitsSolds?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "All Commodity Value (ACV)",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerACVDollarsKPI?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerACVDollarsKPI?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right"
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerACVDollarsKPI?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerACVDollarsKPI?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerACVDollarsKPI?.items?.lastMonth)}M`,
          status: "increase",
          arrow: "left"
        },
      ],
    },
    {
      title: "Dollar Sales per Avg Weekly TPD",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerDollarSoldPerAvgWeeklyTPDs?.items?.lastMonth)}M`,
          status: "increase",
          arrow: "left",
        },
      ],
    },
    {
      title: "Unit Sales per Avg Weekly TPD",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerUnitsSoldPerAvgWeeklyTPDs?.items?.lastMonth)}M`,
          status: "increase",
          arrow: "left",
        },
      ],
    },
    {
      title: "Sales Growth Rate (Dollars Sold)",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerSalesGrowthRateDollarsSolds?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "Average Price Per Unit",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerAveragePricePerUnits?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerAveragePricePerUnits?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.currentMonth)}M`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerAveragePricePerUnits?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerAveragePricePerUnits?.items?.cMvsLM)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerAveragePricePerUnits?.items?.lastMonth)}M`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "% Dollars Sold on Promotion",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.currentMonth)}%`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.cMvsLM)}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnPromotions?.items?.lastMonth)}%`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
    {
      title: "% Dollars Sold on Display",
      values: [
        {
          label: lastYearSameMonth,
          change: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cmcYvsCMLY ? `${truncateDecimal(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cmcYvsCMLY)}%` : "0%",
          value: `$${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.sameMonthLastYear)}M`,
          status: "increase",
          arrow: "right",
        },
        {
          label: currentMonthLabel,
          change: null,
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.currentMonth)}%`,
          status: "nochange",
          arrow: null,
        },
        {
          label: prevMonthLabel,
          change: retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cMvsLM ? `${truncateDecimal(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.cMvsLM)}%` : "0%",
          value: `${formatToMillions(retailersData?.retailerPctDollarsSoldOnDisplays?.items?.lastMonth)}%`,
          status: "decrease",
          arrow: "left",
        },
      ],
    },
  ];

  // Highlight cards data
  const highlightCards = [
    // ─── SUB BRAND BY DOLLAR SALES ───
    {
      title: "#1 Sub Brand by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[0]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[0]?.netSales)}M`,
      bigTitle: retailersData?.retailerSubBrandByDollarsSales?.items[0]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[0]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#2 Sub Brand by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[1]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[1]?.netSales)}M`,
      bigTitle: retailersData?.retailerSubBrandByDollarsSales?.items[1]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[1]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#3 Sub Brand by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[2]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[2]?.netSales)}M`,
      bigTitle: retailersData?.retailerSubBrandByDollarsSales?.items[2]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerSubBrandByDollarsSales?.items[2]?.lastPeriodNetSales)}M`,
    },
    //retailerSKUsByDollarsSales
    // ─── SKU BY DOLLAR SALES ───
    {
      title: "#1 SKU by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[0]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[0]?.netSales)}M`,
      bigTitle: retailersData?.retailerSKUsByDollarsSales?.items[0]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[0]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#2 SKU by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[1]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[1]?.netSales)}M`,
      bigTitle: retailersData?.retailerSKUsByDollarsSales?.items[1]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[1]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#3 SKU by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[2]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[2]?.netSales)}M`,
      bigTitle: retailersData?.retailerSKUsByDollarsSales?.items[2]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerSKUsByDollarsSales?.items[2]?.lastPeriodNetSales)}M`,
    },

    // ─── DIVISION BY DOLLAR SALES ───
    {
      title: "#1 Division by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[0]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[0]?.netSales)}M`,
      bigTitle: retailersData?.retailerDivisionByDollarsSales?.items[0]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[0]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#2 Division by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[1]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[1]?.netSales)}M`,
      bigTitle: retailersData?.retailerDivisionByDollarsSales?.items[1]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[1]?.lastPeriodNetSales)}M`,
    },
    {
      title: "#3 Division by Dollar Sales",
      topLeftLabel: "UNITS SOLD",
      topLeftValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[2]?.unitSold)}M`,
      topRightLabel: "NET SALES",
      topRightValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[2]?.netSales)}M`,
      bigTitle: retailersData?.retailerDivisionByDollarsSales?.items[2]?.name,
      bottomLabel: "UNITS SOLD LY",
      bottomValue: `$${formatToMillions(retailersData?.retailerDivisionByDollarsSales?.items[2]?.lastPeriodNetSales)}M`,
    },
  ];

  const getSubBrandColor = (name) => {
    const colorMap = {
      "C4 Powder": "#C2CF2D",
      "Bloom Pop": "#59A671",
      "Bloom Sparkling Energy": "#C393E4",
      "XTEND": "#C5C5C5",
      "Cellucor": "#747474",
      "C4 Ultimate": "#1A1A1A",
      "C4 Smart Energy": "#1BA4E6",
      "C4 Performance": "#ECD01C",
      "C4": "#C2CF2D",
      "Bloom": "#59A671"
    };

    return colorMap[name] || "#000000";
  };

  const subBrandsconvert = useMemo(() => {
    const items = retailersData?.retailerReportedDollarsSoldBySubBrand?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getSubBrandColor(item.name),
    }));
  }, [retailersData]);

  const getCompetitorColor = (name) => {
    const colorMap = {
      Monster: "#95C11F",
      Celsius: "#F37021",
      Alani: "#00C3DA",
      Ghost: "#F9005A",
      C4: "#FFD100",
      Rockstar: "#FFB300",
      NOS: "#0066CC",
      Bloom: "#C393E4",
      Other: "#000000",
      "Red Bull": "#DA291C",
    };

    return colorMap[name] || "#000000";
  };
  const compitetorconvert = useMemo(() => {
    const items = retailersData?.brandMarketShareByDollarSold?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.brandName,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getCompetitorColor(item.brandName),
    }));
  }, [retailersData]);

  const getRegionColor = (name) => {
    const colorMap = {
      West: "#3BA73B",
      North: "#B5CBEA",
      South: "#9B72C2",
      "South Central": "#FFC081",
      Northeast: "#D93737",
      Central: "#DEDE96",
    };

    return colorMap[name] || "#000000";
  };

  const dataconvertregion = useMemo(() => {
    const items = retailersData?.retailerReportedDollarsSoldByRegion?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getRegionColor(item.name),
    }));
  }, [retailersData]);
  //reportedDollarsSoldByTop5Divisions

  const getDivisionColor = (name) => {
    const colorMap = {
      Sunbelt: "#1A5D2E",
      Northeast: "#472167",
      "Great Lakes": "#5F3F1E",
      "Mid Atlantic": "#511B1B",
      Other: "#000000",
      "Coastal Desert": "#1664D2",
    };

    return colorMap[name] || "#000000";
  };

  const divisiondataconvert = useMemo(() => {
    const items = retailersData?.retailerReportedDollarsSoldByTop5Divisions?.items;

    if (!Array.isArray(items) || items.length === 0) return [];

    return items.map((item) => ({
      label: item.name,
      value: Number(item.percentage?.toFixed(1)) || 0, // or item.percentage
      color: getDivisionColor(item.name),
    }));
  }, [retailersData]);



  const regionChartData = useMemo(() => {
    const items =
      retailersData?.retailerReportedDollarsSoldByRegionSubBrand?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    // ---- X Labels (Regions)
    const xLabels = items.map(item => item.region);

    // ---- Collect ALL unique brands across regions
    const brandSet = new Set();
    items.forEach(item => {
      item.value?.forEach(v => {
        brandSet.add(v.brand);
      });
    });

    const brands = Array.from(brandSet);

    // ---- Build Series using your color function
    const series = brands.map(brand => ({
      label: brand,
      color: getSubBrandColor(brand)
    }));

    // ---- Build Matrix (must match static structure)
    const actual = items.map(regionItem => {
      return brands.map(brand => {
        const found = regionItem.value?.find(v => v.brand === brand);
        return found ? Number(found.value) : 0;
      });
    });

    // ---- Y Axis scaling (same as before)
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues, 0);

    const niceTickStep = (maxVal, tickCount = 5) => {
      if (maxVal === 0) return 1;

      const roughStep = maxVal / tickCount;
      const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
      const residual = roughStep / magnitude;

      let niceResidual;
      if (residual >= 5) niceResidual = 5;
      else if (residual >= 2) niceResidual = 2;
      else niceResidual = 1;

      return niceResidual * magnitude;
    };

    const tickStep = niceTickStep(maxValue, 5);
    const maxTick = tickStep * Math.ceil(maxValue / tickStep);

    const yTicks = [];
    for (let tick = 0; tick <= maxTick + tickStep / 2; tick += tickStep) {
      yTicks.push(Number(tick.toFixed(2)));
    }

    return {
      title: "Reported Dollar Sales by Region",
      xLabels,
      series,
      dataMatrix: actual,   // NOW MATCHES STATIC SAMPLE
      yTicks
    };
  }, [retailersData]);



  console.log(regionChartData, "regionChartDatas")

  const lineChartSubBrandDatas = {
    title: "Reported Dollars Sold by Sub-Brand",

    xLabels: ["Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025", "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025", "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"],

    series: [
      { label: "C4 Performance", color: "#ECD01C" },
      { label: "C4 Smart Energy", color: "#1BA4E6" },
      { label: "C4 Ultimate", color: "#1A1A1A" },
      { label: "Bloom Sparkling Energy", color: "#C393E4" },
      { label: "Bloom Pop", color: "#59A671" },
    ],

    dataMatrix: {
      actual: [
        // Dec
        [40, 10, 8, 2, 5],
        // Jan
        [43, 12, 12, 8, 7],
        // Feb
        [50, 16, 9, 4, 11],
        // Mar
        [47, 13, 14, 9, 8],
        // Apr
        [55, 15, 15, 7, 11],
        //May
        [58, 22, 25, 13, 17],
        // Jun
        [65, 25, 16, 17, 13],
        // Jul
        [58, 18, 19, 13, 16],
        // Aug
        [62, 22, 25, 15, 19],
        // Sep
        [65, 26, 20, 18, 21],
        // Oct
        [69, 31, 22, 24, 28],
        // Nov
        [73, 34, 18, 28, 31],
      ],
    },
  };
  const lineChartSubBrandData = useMemo(() => {
    const items =
      retailersData?.retailerReportedDollarsSoldSubBrandMonthly?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    // ----------------------------
    // Month order for sorting
    const monthOrder = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const sortedItems = [...items].sort((a, b) => {
      const [mA, yA] = a.month.split("-");
      const [mB, yB] = b.month.split("-");
      return new Date(yA, monthOrder.indexOf(mA)) -
        new Date(yB, monthOrder.indexOf(mB));
    });

    // Format X Labels
    const xLabels = sortedItems.map(item => {
      const [m, y] = item.month.split("-");
      return `${m}. ${y}`;
    });

    // Collect unique sub-brands
    const subBrandSet = new Set();
    sortedItems.forEach(item => {
      item.values?.forEach(v => subBrandSet.add(v.subBrandName));
    });

    const subBrands = Array.from(subBrandSet);

    // Build Series (color mapped)
    // ----------------------------
    const series = subBrands.map(name => ({
      label: name,
      color: getSubBrandColor(name)
    }));

    // Convert API → $K values
    // ----------------------------
    let actual = sortedItems.map(item => {
      return subBrands.map(brand => {
        const found = item.values?.find(v => v.subBrandName === brand);
        return found ? Number(found.value) / 1000 : 0;   // $K scale
      });
    });

    // Detect Outlier (C4 spike)
    const allValues = actual.flat();
    const rawMax = Math.max(...allValues, 0);
    const visibleMax =
      rawMax > 100 ? rawMax * 0.25 : rawMax;   // dynamic compression

    actual = actual.map(row =>
      row.map(v => (v > visibleMax ? visibleMax : v))
    );

    const niceTickStep = (maxVal, tickCount = 5) => {
      if (maxVal === 0) return 1;

      const roughStep = maxVal / tickCount;
      const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
      const residual = roughStep / magnitude;

      let niceResidual;
      if (residual >= 5) niceResidual = 5;
      else if (residual >= 2) niceResidual = 2;
      else niceResidual = 1;

      return niceResidual * magnitude;
    };

    const tickStep = niceTickStep(visibleMax, 5);
    const maxTick = tickStep * Math.ceil(visibleMax / tickStep);

    const yTicks = [];
    for (let t = 0; t <= maxTick + tickStep / 2; t += tickStep) {
      yTicks.push(Number(t.toFixed(2)));
    }

    return {
      title: "Reported Dollars Sold by Sub-Brand",
      xLabels,
      series,
      dataMatrix: { actual },
      yTicks
    };

  }, [retailersData]);


  console.log(lineChartSubBrandData, "Reported Dollars Sold by Sub-Brand")

  const commodityVolumeBySubBrandData = useMemo(() => {
    const items = retailersData?.retailerretailerACVDollarsKPISubBrandMonthly?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    // Month order reference
    const monthOrder = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    // Sort months properly (important!)
    const sortedItems = [...items].sort((a, b) => {
      const [monthA, yearA] = a.month.split("-");
      const [monthB, yearB] = b.month.split("-");

      const dateA = new Date(yearA, monthOrder.indexOf(monthA));
      const dateB = new Date(yearB, monthOrder.indexOf(monthB));

      return dateA - dateB;
    });

    //Format xLabels → "Mar. 2025"
    const xLabels = sortedItems.map((item) => {
      const [month, year] = item.month.split("-");
      return `${month}. ${year}`;
    });

    // Get all unique subBrands
    const subBrandSet = new Set();
    sortedItems.forEach((item) => {
      item.value?.forEach((v) => {
        subBrandSet.add(v.subBrand);
      });
    });

    const subBrands = Array.from(subBrandSet);


    const series = subBrands.map((brand) => ({
      label: brand,
      color: getSubBrandColor(brand)
    }));

    //Build dataMatrix.actual
    const actual = sortedItems.map((item) => {
      return subBrands.map((brand) => {
        const match = item.value?.find(
          (v) => v.subBrand === brand
        );
        return match?.value ?? 0;
      });
    });

    //Flatten all values
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues);

    //Nice step generator (for decimal numbers)
    const niceTickStep = (maxVal, tickCount = 5) => {
      const roughStep = maxVal / tickCount;
      const magnitude = Math.pow(10, Math.floor(Math.log10(roughStep)));
      const residual = roughStep / magnitude;

      let niceResidual;
      if (residual >= 5) niceResidual = 5;
      else if (residual >= 2) niceResidual = 2;
      else niceResidual = 1;

      return niceResidual * magnitude;
    };

    const tickStep = niceTickStep(maxValue, 5);
    const maxTick = tickStep * Math.ceil(maxValue / tickStep);

    //Build yTicks
    const yTicks = [];
    for (let tick = 0; tick <= maxTick; tick += tickStep) {
      yTicks.push(Number(tick.toFixed(2)));
    }

    return {
      title: "All Commodity Volume by Sub-Brand",
      xLabels,
      series,
      dataMatrix: {
        actual,
      },
      yTicks
    };
  }, [retailersData]);


  console.log(commodityVolumeBySubBrandData, "commodityVolumeBySubBrandDatas")

  const topSkuChartData = useMemo(() => {
    const items = retailersData?.retailerTop10OrderedSKUsByReportedDollarsSold?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    const normalizeUnits = (val) => {
      if (val == null || val === "-") return 0;
      return Number((Number(val) / 1000).toFixed(1));
    };

    // ---- X Labels (categories)
    const xLabels = items.map(item => item.sku);
    // ---- Data Matrix
    const actual = items.map(item => [
      normalizeUnits(item.value),
      0
    ]);

    // ---- Y-axis ticks (numeric scaling)
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues);

    const tickStep = Math.ceil(maxValue / 5);
    const xTicks = Array.from({ length: 6 }, (_, i) => i * tickStep);

    return {
      title: "Top 10 Ordered SKUs by Reported Dollars Sold",

      xLabels,
      xTicks,

      series: [
        { label: "Units Sold - This Period", key: "thisPeriod", color: "#0A3478" },
        { label: "Units Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" },
      ],

      dataMatrix: { actual },
    };
  }, [retailersData]);

  const bottomSkuChartData = useMemo(() => {
    const items = retailersData?.retailerBottom10OrderedSKUsByReportedDollarsSold?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    const normalizeUnits = (val) => {
      if (val == null || val === "-") return 0;
      return Number((Number(val) / 1000).toFixed(1));
    };

    // ---- X Labels (categories)
    const xLabels = items.map(item => item.sku);

    // ---- Data Matrix
    const actual = items.map(item => [
      normalizeUnits(item.value),
      0 // Backend doesn't provide last period yet
    ]);

    // ---- Same numeric tick logic you used in Top 10 (kept identical)
    const allValues = actual.flat();
    const maxValue = Math.max(...allValues);

    const tickStep = Math.ceil(maxValue / 5);
    const xTicks = Array.from({ length: 6 }, (_, i) => i * tickStep);

    return {
      title: "Bottom 10 Ordered SKUs by Reported Dollars Sold",

      xLabels,
      xTicks,

      series: [
        { label: "Units Sold - This Period", key: "thisPeriod", color: "#0A3478" },
        { label: "Units Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" },
      ],

      dataMatrix: {
        actual,
      },
    };
  }, [retailersData]);




  const brandSalesChartData = useMemo(() => {
    const items = retailersData?.retailerReportedDollarsBrandCompetitors?.items;

    if (!Array.isArray(items) || items.length === 0) return null;

    // ---- X Labels (Brand Names)
    const xLabels = items.map(item => item.brandName);

    // ---- Helper to convert to Millions (since chart shows $M)
    const toMillions = (val) => Number((Number(val || 0) / 1_000_000).toFixed(3));

    // ---- Build dataMatrix.actual  [lastYear, currentYear]
    const actual = items.map(item => [
      toMillions(item.lastYear),     // Last Period
      toMillions(item.currentYear),  // This Period
    ]);

    // ---- Series with special color handling
    const baseSeries = [
      { label: "Dollars Sold - Last Period", key: "last", color: "#8EB7DB" },
      { label: "Dollars Sold - This Period", key: "current", color: "#0A3A73" },
    ];

    // Override colors for specific brands (C4 & Bloom)
    const customSeriesOverrides = items.flatMap(item => {
      if (item.brandName === "C4") {
        return [
          { label: "C4 - Last Period", key: "last", color: "#D6C85F" },
          { label: "C4 - This Period", key: "current", color: "#EACF2F" },
        ];
      }

      if (item.brandName === "Bloom") {
        return [
          { label: "Bloom - Last Period", key: "last", color: "#D9C3E9" },
          { label: "Bloom - This Period", key: "current", color: "#C393E4" },
        ];
      }

      return [];
    });

    const series = [...baseSeries, ...customSeriesOverrides];

    return {
      title: "Reported Dollars Sold by Brand",
      xLabels,
      series,
      dataMatrix: {
        actual
      }
    };
  }, [retailersData]);
  console.log(brandSalesChartData, "brandSalesChartDatas")
  const normalizePrice = (value) => (value != null ? value / 40 : 0);

  const brandPriceComparison = useMemo(() => {
    const items = retailersData?.basePriceVsPromotedPrice?.items ?? [];

    const brandMap = {};

    items.forEach((item) => {
      const brand = item.brandName;
      if (!brand) return;

      if (!brandMap[brand]) {
        brandMap[brand] = {
          promoLast: [],
          baseLast: [],
          promoCurrent: [],
          baseCurrent: [],
        };
      }

      if (item.avgPromoPriceMTDLast != null) brandMap[brand].promoLast.push(normalizePrice(item?.avgPromoPriceMTDLast));

      if (item.basePriceMTDLast != null) brandMap[brand].baseLast.push(normalizePrice(item?.basePriceMTDLast));

      // fallback to QTD/YTD for current
      const promoCurrent = item?.avgPromoPriceMTDCurrent ?? item?.avgPromoPriceQTDCurrent ?? item?.avgPromoPriceYTDCurrent;

      const baseCurrent = item?.basePriceMTDCurrent ?? item?.basePriceQTDCurrent ?? item?.basePriceYTDCurrent;

      if (promoCurrent != null) brandMap[brand].promoCurrent.push(normalizePrice(promoCurrent));

      if (baseCurrent != null) brandMap[brand].baseCurrent.push(normalizePrice(baseCurrent));
    });

    const avg = (arr) => (arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0);

    const brands = Object.keys(brandMap);

    const dataMatrix = {
      actual: brands.map((brand) => {
        const b = brandMap[brand];
        return [avg(b.promoLast), avg(b.baseLast), avg(b.promoCurrent), avg(b.baseCurrent)];
      }),
    }
    const allValues = dataMatrix?.actual?.flat();
    const maxValue = Math.max(...allValues);

    // Avoid zero issue
    let yTicks = [0];

    if (maxValue > 0) {
      const rawStep = maxValue / 5;

      const magnitude = Math.pow(
        10,
        Math.floor(Math.log10(rawStep))
      );

      const niceStep = Math.ceil(rawStep / magnitude) * magnitude;

      yTicks = Array.from({ length: 6 }, (_, i) =>
        Number((i * niceStep).toFixed(2))
      );

    }
    return {
      title: "Brand Base Price vs Promoted Price",

      xLabels: brands,

      series: [
        { label: "Average Promo Price - Last Period", color: "#8C8C8C" },
        { label: "Base Price - Last Period", color: "#D8C72C" },
        { label: "Average Promo Price - This Period", color: "#000000" },
        { label: "Base Price - This Period", color: "#FFE000" },
      ],

      dataMatrix,

      yTicks
    };
  }, [retailersData]);

  const stateNameToCode = {
    Alabama: "AL",
    Alaska: "AK",
    Arizona: "AZ",
    Arkansas: "AR",
    California: "CA",
    Colorado: "CO",
    Connecticut: "CT",
    Delaware: "DE",
    Florida: "FL",
    Georgia: "GA",
    Hawaii: "HI",
    Idaho: "ID",
    Illinois: "IL",
    Indiana: "IN",
    Iowa: "IA",
    Kansas: "KS",
    Kentucky: "KY",
    Louisiana: "LA",
    Maine: "ME",
    Maryland: "MD",
    Massachusetts: "MA",
    Michigan: "MI",
    Minnesota: "MN",
    Mississippi: "MS",
    Missouri: "MO",
    Montana: "MT",
    Nebraska: "NE",
    Nevada: "NV",
    New_Hampshire: "NH",
    New_Jersey: "NJ",
    New_Mexico: "NM",
    New_York: "NY",
    North_Carolina: "NC",
    North_Dakota: "ND",
    Ohio: "OH",
    Oklahoma: "OK",
    Oregon: "OR",
    Pennsylvania: "PA",
    Rhode_Island: "RI",
    South_Carolina: "SC",
    South_Dakota: "SD",
    Tennessee: "TN",
    Texas: "TX",
    Utah: "UT",
    Vermont: "VT",
    Virginia: "VA",
    Washington: "WA",
    West_Virginia: "WV",
    Wisconsin: "WI",
    Wyoming: "WY",
  };
  const thickBorderStates = [
    "CA", "AZ", "NM", "TX", "OK", "MO", "IL",
    "IN", "KY", "TN", "GA", "NC", "VA"
  ];
  const legendData = [
    { label: "$0–$5M", color: "#C8C6C4", min: 0, max: 5000000 },
    { label: "$5M–$10M", color: "#D0EBBE", min: 5000000, max: 10000000 },
    { label: "$10M–$20M", color: "#B7E29A", min: 10000000, max: 20000000 },
    { label: "$20M–$35M", color: "#99D56F", min: 20000000, max: 35000000 },
    { label: "$35M–$50M", color: "#6BB542", min: 35000000, max: 50000000 },
    { label: "$50M+", color: "#4C8C17", min: 50000000, max: Infinity },
  ];
  const usemapData = useMemo(() => {
    const items = retailersData?.retailerReportedDollarsSoldByState?.items;

    const usaData = {};
    if (Array.isArray(items)) {
      items.forEach(item => {
        const stateCode = stateNameToCode[item.stateName] || item.stateName;
        usaData[stateCode] = item.ytdValue ?? 0;
      });
    }

    return {
      usaData, // will at least be an empty object
      thickBorderStates,
      legendData,
    };
  }, [retailersData]);

  console.log(usemapData, "usedata")
  return (
    <DashboardLayout>
      <MDBox
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "none",
          },
        }}
      >
        <AppHeader />
      </MDBox>
      <Box
        sx={{
          position: "sticky", // better than fixed
          top: 0,
          zIndex: 10,
          bottom: 0,
          // background: "red",
        }}
      >
        <Box
          sx={{
            ml: 0,
            transition: "margin-left 0.25s ease",
            "& .MuiBox-root": { backgroundImage: "none" },
          }}
          style={{
            // backgroundColor: '#f8f9fa',
            minHeight: "100vh",
            padding: isMobile ? "8px" : "0px 16px 100px 16px",
            paddingBottom: "100px",
            fontFamily: "inter",
          }}
        >
          {/* Loading Backdrop */}
          <Backdrop
            open={loading}
            sx={{
              position: "fixed",
              zIndex: (theme) => theme.zIndex.drawer + 1,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <CircularProgress color="primary" />
          </Backdrop>
          {/* Header */}
          <Box style={{ display: "flex", alignItems: "center", height: "68px", background: "none" }}>
            <Box sx={{ background: "none" }}>
              <Box sx={{ width: 48, height: 48, borderRadius: "50%", boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.12)" }}>{retail?.logo ? <img src={retail?.logo || ""} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} /> : ""}</Box>
            </Box>
            <Box sx={{ ml: "10px" }}>
              <Box sx={{ background: "none", display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontSize: "24px", fontWeight: 300, color: "#111111", lineHeight: "1 !important" }}>{retail?.name}</Typography>
                <Typography sx={{ fontSize: "12px", color: "rgba(17, 17, 17, 0.5)", fontWeight: 300, lineHeight: "1 !important" }}>{retail?.parent}</Typography>
              </Box>
            </Box>
            <Box sx={{ ml: "4px" }}>
              <Box sx={{ display: "flex" }}>
                <Box
                  sx={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    bgcolor: "#25A73E",
                    boxShadow: "0px 0px 4px rgba(16, 125, 37, 0.5)",
                    mt: "-8px",

                    // marginTop: "1.2rem"
                  }}
                />
              </Box>
            </Box>
          </Box>
          {/* Blue Underline */}
          <Box
            sx={{
              width: "100%",
              height: "4px",
              background: "#115f9d",
              borderRadius: "0px",
              mb: 0,
              width: "calc(100% + 80px)",
              ml: "-40px",
              mr: "-40px",
              position: "relative",
              zIndex: 11,
            }}
            className="gradient-line-Retailers"
          />
          <Box
            sx={{
              height: "calc(100vh - 80px)", // adjust if header height changes
              overflowY: "auto",
              // px: isMobile ? 1 : 2,
              pb: "100px",
              /* smooth scrolling */
              scrollBehavior: "smooth",
              WebkitOverflowScrolling: "touch", // iOS momentum

              /* hide scrollbar */
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE / Edge
              "&::-webkit-scrollbar": {
                display: "none", // Chrome / Safari
              },
            }}
          >
            {/* Section Title: KPI's */}
            <Typography sx={{ fontSize: "16px", mb: 1, mt: 3, display: "flex", gap: "4px", alignItems: "center" }}>
              <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>Retailers / </span>
              <span style={{ fontSize: "16px", fontWeight: 200 }}>
                {retail?.name} ({retail?.color})
              </span>
            </Typography>
            <Box sx={{ width: "100%", height: "1px", background: "rgba(22, 114, 185, 0.1)", borderRadius: "2px", mb: 2 }} />

            <Box sx={{ minHeight: "auto" }}>
              <Grid container rowSpacing={2} alignItems="stretch">
                {/* LEFT CARD – responsive */}
                <Grid
                  item
                  xs={12}
                  md={3}
                  sx={{
                    pl: "8px !important", // REQUIRED
                  }}
                >
                  {accordionData.map((item, index) => (
                    <Accordion
                      key={index}
                      expanded={expanded === `panel${index}`}
                      onChange={handleChange(`panel${index}`)}
                      elevation={0}
                      sx={{
                        borderRadius: "12px !important",
                        overflow: "hidden",
                        mb: 2,
                        boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      {/* HEADER */}
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#A7B2BE" }} />}
                        sx={{
                          bgcolor: "#fff",
                          // borderBottom: "1px solid #f1f1f1",
                          // remove default height
                          minHeight: "unset",

                          //exact vertical padding
                          paddingTop: "16px",
                          paddingBottom: "24PX",
                          px: "20px",

                          // FIX inner content spacing
                          "& .MuiAccordionSummary-content": {
                            margin: 0,
                          },

                          // also fix expanded state
                          "&.Mui-expanded": {
                            minHeight: "unset",
                          },
                          "&.Mui-expanded .MuiAccordionSummary-content": {
                            margin: 0,
                          },
                        }}
                      >
                        <Typography sx={{ color: "#1672B9", fontWeight: 200, fontSize: 16 }}>{item.title}</Typography>
                      </AccordionSummary>
                      {/* CONTENT */}
                      <AccordionDetails sx={{ px: 2.5, pb: "20px", pt: 0, marginBottom: miniSidenav ? "7.5rem !important" : "7.7rem !important", bgcolor: "#fff" }}>
                        <Box>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Channel</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}> {item.Channel}</Typography>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Coverage</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.Coverage}</Typography>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Parent Company</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.ParentCompany}</Typography>
                          <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Route To market</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.RouteTomarket}</Typography>
                          {/* Number Of Doors */}
                          <Typography sx={{ color: "#11111180", fontSize: 10, fontWeight: 200 }}>Number Of Doors</Typography>
                          <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.doors}</Typography>
                          {/* Status */}
                          <Typography sx={{ color: "#11111180", fontSize: 10, fontWeight: 200 }}>Status</Typography>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography sx={{ fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.status}</Typography>

                            {item.status === "Active" && (
                              <Box
                                sx={{
                                  width: 8,
                                  height: 8,
                                  borderRadius: "50%",
                                  bgcolor: "#25A73E",
                                }}
                              />
                            )}
                          </Box>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Grid>

                {/* RIGHT CONTENT */}
                <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{
                    pl: 2,
                    // display: "flex",
                    // flexDirection: "column",
                    pr: "8px !important", // REQUIRED
                  }}
                >
                  <Grid container spacing={2}>
                    {/* TOP ROW – 4 Cards */}
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        {metricData.map((item, index) => (
                          <Grid item xs={12} sm={6} lg={3} key={index}>
                            <Card
                              sx={{
                                width: "100%",
                                borderRadius: "12px",
                                padding: "12px 8px 12px 16px",
                                height: miniSidenav ? "auto" : "auto",
                                boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                                display: "flex",
                                flexDirection: "row",
                                border: "none !important",
                                // gap: "6px"
                              }}
                            >
                              <Box sx={{ width: miniSidenav ? "80%" : "82%" }}>
                                <Typography
                                  sx={{
                                    fontSize: miniSidenav ? 12 : 13,
                                    fontWeight: 300,
                                    color: "#1672B9",
                                    minHeight: miniSidenav ? 0 : "auto",
                                  }}
                                >
                                  {item.title}
                                </Typography>
                                <Box>
                                  <Typography sx={{ fontSize: 32, fontWeight: 500, lineHeight: 1, mt: "6px !important", color: "#111111" }}>{item.value}</Typography>
                                  {/* Growth Row */}
                                  <Box sx={{ display: "flex", alignItems: "center", mt: "6px !important" }}>
                                    <Chip
                                      icon={<ArrowDropUpIcon />}
                                      label={`${item.growth}`}
                                      sx={{
                                        background: "rgba(0, 143, 12, 0.25)",
                                        color: "#008F0C",
                                        fontWeight: 400,
                                        height: 20,
                                        mr: "6px",
                                        border: "1px solid rgba(0, 143, 12, 0.25)",

                                        /* IMPORTANT: remove default padding */
                                        padding: 0,

                                        /* Chip root controls left/right breathing space */
                                        "& .MuiChip-root": {
                                          padding: 0,
                                        },

                                        /* ICON */
                                        "& .MuiChip-icon": {
                                          fontSize: 16,
                                          color: "#008F0C",
                                          marginLeft: "8px", //left space
                                          marginRight: "4px", //space between icon & value
                                        },

                                        /* LABEL */
                                        "& .MuiChip-label": {
                                          paddingLeft: "0px !important",
                                          paddingRight: "8px !important", //right space
                                          fontSize: 10,
                                          fontWeight: 300,
                                          lineHeight: 1,
                                        },
                                      }}
                                    />

                                    <Typography
                                      sx={{
                                        fontSize: 10,
                                        color: "rgba(17, 17, 17, 0.25)",
                                        fontWeight: 300,
                                      }}
                                    >
                                      YTD
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>
                              <Box
                                sx={{
                                  width: miniSidenav ? "20%" : "18%",
                                  display: "flex",
                                  alignItems: "flex-start",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <IconButton
                                  size="small"
                                  sx={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: "50%",
                                    border: "1.5px solid rgba(22, 114, 185, 0.25)",
                                  }}
                                >
                                  <ArrowOutwardIcon sx={{ fontSize: 16, color: "rgba(22, 114, 185, 0.25)" }} />
                                </IconButton>
                              </Box>
                              {/* Top Row: Title + Arrow */}
                              {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                        <Typography
                                                            sx={{
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: "#1672B9",
                                                            }}
                                                        >
                                                            {item.title}
                                                        </Typography>
                                                        <IconButton
                                                            size="small"
                                                            sx={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: "50%",
                                                                border: "1px solid rgba(22, 114, 185, 0.25)",
                                                            }}
                                                        >
                                                            <ArrowOutwardIcon sx={{ fontSize: 16, color: "rgba(22, 114, 185, 0.25)" }} />
                                                        </IconButton>
                                                    </Box> */}
                              {/* Bottom Stats */}
                              {/* <Box>
                                                        <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
                                                            {item.value}
                                                        </Typography>
                                                      
                                                        <Box sx={{ display: "flex", alignItems: "center", mt: '6px !important' }}>
                                                            <Chip
                                                                icon={<ArrowDropUpRoundedIcon />}
                                                                label={`${item.growth}`}
                                                                sx={{
                                                                    background: "rgba(0, 143, 12, 0.25)", // 25% opacity
                                                                    color: "#008F0C",
                                                                    fontWeight: 600,
                                                                    height: 24,
                                                                    mr: "6px",
                                                                    border: "1px solid rgba(0, 143, 12, 0.25)",
                                                                    // FIX: override chip icon styles
                                                                    "& .MuiChip-icon": {
                                                                        fontSize: "22px !important",      // icon size
                                                                        color: "#008F0C",
                                                                        marginLeft: '8px'
                                                                    },
                                                                    "& .MuiChip-label": {
                                                                        paddingLeft: "4px !important",
                                                                        paddingRight: "8px !important"
                                                                    }
                                                                }}
                                                            />
                                                            <Typography sx={{ fontSize: 10, color: "rgba(17, 17, 17, 0.25)" }}>YTD</Typography>
                                                        </Box>
                                                    </Box> */}
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>

                    {/* BOTTOM FULL WIDTH */}
                    <Grid item xs={12}>
                      <Card
                        sx={{
                          borderRadius: "12px",
                          p: 2,
                          bgcolor: "#fff",
                          boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                          border: "none !important",
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Grid container spacing={2}>
                          {/* ---------- MAP 1 SECTION ---------- */}
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                color: "#2B9BE3",
                                fontWeight: 300,
                                fontSize: 14,
                                mb: 1.5,
                              }}
                            >
                              Active Doors Map
                            </Typography>

                            <div style={{ height: 500, width: "100%" }}>
                              <MapContainer center={[39.5, -98.35]} zoom={4} minZoom={4} maxZoom={6} zoomControl={false} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
                                <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}" />

                                {Object.entries(CITY_COORDS).map(([key, coords], i) => (
                                  <Marker key={i} position={coords} icon={pinIcon} />
                                ))}
                              </MapContainer>
                            </div>
                          </Grid>

                          {/* ---------- TABLE SECTION ---------- */}
                          <Grid item xs={12} md={6} sx={{ background: "none" }}>
                            <Box sx={{ height: 500, overflowY: "auto", overflowX: "auto", mt: 4.5 }}>
                              {/* Header Row */}
                              <Box sx={{ display: "flex", borderBottom: "1px solid #1672B91A", position: "sticky", top: 0, bgcolor: "#fff", zIndex: 1, right: 0, width: "max-content" }}>
                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Region</Box>
                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Division</Box>
                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>State</Box>
                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Number</Box>
                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Full Address</Box>
                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Locations</Box>
                              </Box>
                              {/* Data Rows */}
                              {formateddata.map((row, index) => (
                                <Box
                                  key={index}
                                  sx={{
                                    display: "flex",
                                    borderBottom: "1px solid #f0f0f0",
                                    "&:hover": { bgcolor: "#f9f9f9" },
                                    background: "none",
                                  }}
                                >
                                  <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Region}</Box>
                                  <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Division}</Box>
                                  <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.stateName}</Box>
                                  <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Store}</Box>
                                  <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Address}</Box>
                                  <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.City}</Box>
                                </Box>
                              ))}
                            </Box>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            {/* Section Title: KPI's */}
            <Typography sx={{ fontSize: "16px", mt: 3, display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                {retail?.name} ({retail?.color}) /{" "}
              </span>{" "}
              <span style={{ fontSize: "16px", fontWeight: 200 }}>KPI's</span>
            </Typography>
            <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mt: "8px" }} />
            <KpiMetricscards cardsData={Kpiscardsdata} />

            {/* Section Title: Time series */}
            <Typography sx={{ fontSize: "16px", mt: 3, display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                {retail?.name} ({retail?.color}) /{" "}
              </span>
              <span style={{ fontSize: "16px", fontWeight: 200 }}>Time Series</span>
            </Typography>
            <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mt: "8px" }} />

            <TimeSeriescards timeSeriesCards={timeSeriesCardsdata} />
            {/* Section Title: Highlights */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: "24px" }}>
              <Typography sx={{ fontSize: "16px" }}>
                <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px" }}>
                  {retail?.name} ({retail?.color}) /{" "}
                </span>{" "}
                <span style={{ fontSize: "16px", fontWeight: 200 }}>Highlights</span>
              </Typography>
              <Box sx={{ display: "flex", gap: 1 }}>
                {["YTD", "QTD", "MTD"].map((label, idx) => (
                  <FilterChip key={label} label={label} idx={idx} activeIdx={activeIdx} onClick={setActiveIdx} />
                ))}
              </Box>
            </Box>
            <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mt: "8px" }} />
            <HighlightsCards data={highlightCards} />
            <Box sx={{ mt: 3 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
                <Typography sx={{ fontSize: "16px" }}>
                  <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>
                    {retail?.name} ({retail?.color}) /{" "}
                  </span>{" "}
                  <span style={{ fontSize: "16px", fontWeight: 200 }}>Visualizations</span>
                </Typography>

                <Box sx={{ display: "flex", gap: 1 }}>
                  {["YTD", "QTD", "MTD"].map((label, idx) => (
                    <FilterChip key={label} label={label} idx={idx} activeIdx={activeIdx} onClick={setActiveIdx} />
                  ))}
                </Box>
              </Box>

              <Box sx={{ width: "100%", height: "1px", background: "#1672B91A", borderRadius: "2px", mb: 0 }} />
            </Box>
            <Grid
              container
              rowSpacing={2}
              columnSpacing={2}
              sx={{
                mt: "26px !important",
                alignItems: "stretch", // keeps all cards same height
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "0px !important", sm: "0px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Dollars Sold by Sub Brand" data={subBrandsconvert} />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Brand Marketshare by Dollars Sold" data={compitetorconvert} />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Dollars Sold by Region" data={dataconvertregion} />
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                sx={{
                  pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" },
                }}
              >
                <PieLegendCard title="Reported Dollars Sold by Top 5 Divisions" data={divisiondataconvert} />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: "10px !important" }}>
              {/* LEFT CARD - USA MAP */}
              <Grid item xs={12} md={4}>
                <Map title="Reported Dollars Sold Heatmap by State" usaData={usemapData} thickBorderStates={thickBorderStates} legendData={legendData} />
              </Grid>

              {/* RIGHT CARD - BAR CHART */}
              <Grid item xs={12} md={8}>
                {regionChartData && (
                  <Barcharts
                    title={regionChartData.title}
                    xLabels={regionChartData.xLabels}
                    series={regionChartData.series}
                    dataMatrix={regionChartData.dataMatrix}
                    yTicks={regionChartData.yTicks}
                    rounded={true}
                    yAxisLabel="Net Sales ($M)"
                  />
                )}

              </Grid>
            </Grid>
            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                {lineChartSubBrandData && (
                  <LineChartSubBrand
                    title={lineChartSubBrandData.title}
                    xLabels={lineChartSubBrandData.xLabels}
                    series={lineChartSubBrandData.series}
                    dataMatrix={lineChartSubBrandData.dataMatrix}
                    yTicks={lineChartSubBrandData.yTicks}
                    valueFormatter={(v) => `$${v}M`}
                    yAxisLabel="Reported Dollars Sold ($M)"
                  />
                )}

              </Grid>
            </Grid>
            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                {commodityVolumeBySubBrandData?.title &&
                  commodityVolumeBySubBrandData?.xLabels?.length > 0 &&
                  commodityVolumeBySubBrandData?.series?.length > 0 &&
                  commodityVolumeBySubBrandData?.dataMatrix?.actual?.length > 0 && (
                    <LineChartSubBrand
                      title={commodityVolumeBySubBrandData.title}
                      xLabels={commodityVolumeBySubBrandData.xLabels}
                      series={commodityVolumeBySubBrandData.series}
                      dataMatrix={commodityVolumeBySubBrandData.dataMatrix}
                      yTicks={commodityVolumeBySubBrandData.yTicks}
                      valueFormatter={(v) => `${v}M`}
                      yAxisLabel="All Commodity Volume (%)"
                    />
                  )}

              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: "34px !important" }}>
              {/* LEFT CARD - USA MAP */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  pt: { xs: "0px !important", sm: "0px !important" },
                }}
              >
                {topSkuChartData && (
                  <TopSkuBarChart
                    title={topSkuChartData.title}
                    xLabels={topSkuChartData.xLabels}
                    series={topSkuChartData.series}
                    dataMatrix={topSkuChartData.dataMatrix}
                    xTicks={topSkuChartData.xTicks}
                  />
                )}

              </Grid>

              {/* RIGHT CARD - BAR CHART */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  pt: { xs: "34px !important", sm: "34px !important", md: "0px !important" },
                }}
              >
                {bottomSkuChartData && (
                  <TopSkuBarChart
                    title={bottomSkuChartData.title}
                    xLabels={bottomSkuChartData.xLabels}
                    series={bottomSkuChartData.series}
                    dataMatrix={bottomSkuChartData.dataMatrix}
                    xTicks={bottomSkuChartData.xTicks}
                  />
                )}

              </Grid>
            </Grid>
            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                {brandSalesChartData && (
                  <DoubleBarChart
                    title={brandSalesChartData.title}
                    xLabels={brandSalesChartData.xLabels}
                    series={brandSalesChartData.series}
                    dataMatrix={brandSalesChartData.dataMatrix}
                    yTicks={brandSalesChartData.yTicks}
                  />
                )}

              </Grid>
            </Grid>

            <Grid container sx={{ mt: "34px !important" }}>
              <Grid item xs={12}>
                <BrandPriceDumbbellChart title={brandPriceComparison.title} xLabels={brandPriceComparison.xLabels} series={brandPriceComparison.series} dataMatrix={brandPriceComparison.dataMatrix} yTicks={brandPriceComparison.yTicks} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default RetailsDetailspage;
